import React from 'react'
import { useBoldText } from '../../hooks/useBoldText'
import '../../styles/ConciergeModule/GreetingStep.scss'

interface GreetingStepProps {
  step: string,
  index: number
}

export const GreetingStep = ({ step, index }: GreetingStepProps) => {
  return <div className='greeting-step'>
        <span className='step-number'>{index}</span>
        <p>{useBoldText(step)}</p>
    </div>
}
